import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { View, Platform, ScrollView, Text, Image } from 'react-native';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { PnmacCard, PnmacCardTitle, PnmacCardContent, PnmacImage, PnmacModal, PnmacParagraph, PnmacUIButton, PnmacText, PnmacCardActions, PnmacNavigation, PnmacDullBottomButton, PnmacMobileButton } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { textStyle } from "../../v2/theme";
var eDisbursementPopup = /** @class */function (_super) {
  __extends(eDisbursementPopup, _super);
  function eDisbursementPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      open: false
    };
    return _this;
  }
  eDisbursementPopup.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      translations = _a.translations,
      layout = _a.layout,
      matches = _a.matches,
      addTracker = _a.addTracker,
      closeEdisbursementPopup = _a.closeEdisbursementPopup,
      closePaperlessPopup = _a.closePaperlessPopup;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        maxHeight: '90%',
        maxWidth: matches.small ? "95%" : matches.medium ? "50%" : "30%",
        backgroundColor: "#f5f5f5",
        borderRadius: 10,
        alignSelf: "center"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(ScrollView, {
      style: {
        maxHeight: 400
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20,
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        size: 18,
        fontWeight: "bold",
        fontColor: "#003087"
      })
    }, translations === null || translations === void 0 ? void 0 : translations.EDisbursementsLogoLine), /*#__PURE__*/React.createElement(Image, {
      style: {
        marginLeft: 10,
        height: 30,
        width: 30
      },
      source: require('../../assets/dollar-icon-whitebg.png')
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, layout.isPrivateLabel ? translations === null || translations === void 0 ? void 0 : translations.PLEDisbursementsAccessStatement : translations === null || translations === void 0 ? void 0 : translations.EDisbursementsAccessStatement)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.EDisbursementsReduceRiskOfTheft)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20,
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.PennyPaperlessSignUp))), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        justifyContent: "space-between",
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        //addTracker("eDisb signUp Button Clicked")
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "eDisb signUp Button Clicked", 0);
        PnmacNavigation(__assign({
          action: "/Account/eDisbursement",
          wind: true,
          target: "_self"
        }, _this.props));
        closeEdisbursementPopup();
        closePaperlessPopup();
      },
      style: styles.eDisbursementPopup.button
    }, translations === null || translations === void 0 ? void 0 : translations.signUp)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'outlined',
      onPress: function () {
        //addTracker("eDisb Not Now Button Clicked")
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "eDisb Not Now Button Clicked", 0);
        closeEdisbursementPopup();
        closePaperlessPopup();
      }
    }, translations === null || translations === void 0 ? void 0 : translations.notNow)))));
  };
  return eDisbursementPopup;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(eDisbursementPopup);